// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import AceEditor from 'react-ace';
import 'brace';
import 'brace/theme/monokai';
import 'brace/ext/searchbox';

// Containers
import withFormField from '../../containers/with-form-field';

// Styles
import './input-ide.scss';

class InputIde extends Component {
    componentWillMount() {
        const {mode = 'drools'} = this.props;

        // eslint-disable-next-line import/no-dynamic-require
        require(`brace/mode/${mode}`);
    }

    componentWillUnmount() {
        clearInterval(this.resizeInterval);
    }

    getClass() {
        const {className} = this.props;

        return classnames('input-ide', className);
    }

    getProps() {
        const {aceProps, mode = 'drools', name, onBlur, onClick, readOnly, value} = this.props;

        return {
            aceProps,
            className: this.getClass(),
            editorProps: {$blockScrolling: Infinity},
            maxLines: Infinity,
            minLines: 30,
            mode,
            name,
            onBlur,
            onChange: this.handleChange,
            onClick,
            onLoad: this.handleLoad,
            readOnly,
            ref: (aceEditor) => (this.aceEditor = aceEditor),
            showPrintMargin: false,
            theme: 'monokai',
            value,
            width: '100%',
            wrapEnabled: true,
        };
    }

    handleChange = (value) => {
        const {onChange} = this.props;

        if (onChange) {
            onChange({}, value);
        }
    };

    handleLoad = (editor) => {
        editor.getSession().setUseWorker(true);

        this.resizeInterval = setInterval(() => {
            editor.resize();
        }, 1000);
    };

    render() {
        return <AceEditor {...this.getProps()} />;
    }
}

InputIde.propTypes = {
    aceProps: PropTypes.object,
    className: PropTypes.string,
    mode: PropTypes.string,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    readOnly: PropTypes.bool,
    value: PropTypes.string,
};

export default withFormField(InputIde);

export const Ide = InputIde;
